import React, { useState, useEffect } from 'react';
import { checkProductSddNddEligiblity } from '../../../../src/datafetchers/productPage';
import { CheckDeliveryTime } from './styled';
import { images } from '../../../Constants/ImageUrls';
import { fireEvent } from '../../../Utils/fireEvent';
import { getWebUserId } from '../../../Utils/helper';

const PdpNddSddStrip = (props) => {
  const { productData, sddNddData, userType } = props;
  const [pincode, setPincode] = useState(
    sddNddData.courierEddData.deliveryPincode,
  );
  const [deliveryData, setDeliveryData] = useState(sddNddData?.eddData);
  const [addressData, setAddressData] = useState(sddNddData);
  const [buttonText, setButtonText] = useState('CHANGE');
  const [isLoading, setIsLoading] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState('');
  const [showDispatchTime, setShowDispatchTime] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    fireEvent({
      category: 'viewed_sdd_ndd_component',
      parent: pincode,
    });
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      const currentTime = new Date();
      const maxOrderTime = new Date();
      maxOrderTime.setHours(16, 0, 0, 0);

      const leftTime = maxOrderTime - currentTime;
      if (leftTime <= 0) {
        setTimeRemaining(null);
        return;
      }

      const hours = Math.floor(leftTime / (1000 * 60 * 60));
      const minutes = Math.floor((leftTime % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((leftTime % (1000 * 60)) / 1000);

      setTimeRemaining(
        `${hours ? `${hours}hr` : ''} ${
          minutes ? `${minutes}min` : ''
        } ${seconds ? `${seconds}sec` : ''}`,
      );
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleChange = (e) => {
    const pin = e.target.value;
    if (pin.includes('.') || pin.includes('-')) {
      setError('Please enter a valid pincode');
      return;
    }
    if (pin.length <= 6) {
      setPincode(pin);
      setError('');
      if (buttonText === 'CHANGE') {
        setButtonText('CHECK');
      }
    }
    e.target.value = pin.slice(0, 6);
  };

  const handleClick = async () => {
    if (pincode.length !== 6) {
      setError('You must enter a 6 digit pincode!');
      return;
    } else {
      setIsLoading(true);
      const body = {
        productId: productData?.id.toString(),
        totalOrderValue: productData?.price,
        pincode: parseInt(pincode),
        webUserId: getWebUserId(),
        userType: userType,
      };
      const res = await checkProductSddNddEligiblity(body);

      setDeliveryData(res?.data?.eddData);
      setButtonText('CHANGE');
      setIsLoading(false);

      fireEvent({
        category: 'clicked_sdd_ndd_button',
        parent: pincode,
        support_variable: res?.data?.NddSddEligible,
      });

      if (!res?.data?.pincodeServicable || pincode == 0) {
        setError('This pincode is not servicable!');
      }

      if (!res?.data?.NddSddEligible || pincode == 0) {
        setShowDispatchTime('We dispatch the order within 24 hours');
      } else {
        setShowDispatchTime('');
      }

      if (res.data?.pincodeServicable) {
        setAddressData(res?.data);
      }
    }
  };

  const handleChangeClick = async () => {
    setDeliveryData(sddNddData.eddData);
    setButtonText('CHECK');
    setError('');
  };
  return (
    <CheckDeliveryTime>
      {buttonText == 'CHECK' || error ? 'CHECK YOUR PINCODE' : 'DELIVERING TO:'}
      <div className="pincodeContainer">
        <div className="pincodeInput">
          {buttonText == 'CHECK' || error ? (
            <input
              type="number"
              value={pincode === 0 ? '' : pincode}
              placeholder={
                sddNddData?.courierEddData?.deliveryPincode
                  ? sddNddData?.courierEddData?.deliveryPincode
                  : 'Enter Delivery Pincode'
              }
              onChange={handleChange}
              onKeyDown={(e) => {
                if (e.key === '-' || e.key === '.') {
                  e.preventDefault();
                }
              }}
            />
          ) : (
            <div className="addressDetails">
              {pincode}
              <br />
              <p>
                {addressData?.city}
                {', '}
                {addressData?.state}
              </p>
            </div>
          )}

          <button
            {...(buttonText == 'CHECK'
              ? { onClick: handleClick }
              : { onClick: handleChangeClick })}
          >
            {buttonText}
            {isLoading ? <img src={images?.loadingGif} alt="loading" /> : null}
          </button>
        </div>
        <div className="errorMessage">{error && <p>{error}</p>}</div>
      </div>
      {buttonText == 'CHANGE' ? (
        <div
          style={{
            borderTop: error ? 'none' : '1px dashed rgba(0, 0, 0, 0.4)',
            background: 'transparent',
          }}
        ></div>
      ) : null}
      {!showDispatchTime ? (
        <>
          {' '}
          <div className="deliveryTimeContainer">
            <div>
              <div className="deliveryTime">
                {deliveryData?.orderEdd ? (
                  <>
                    Get FREE Delivery by : <span>{deliveryData.orderEdd}</span>
                  </>
                ) : sddNddData?.eddData?.orderEdd ? (
                  <>
                    Get FREE Delivery by :{' '}
                    <span>{sddNddData.eddData.orderEdd}</span>
                  </>
                ) : null}
              </div>
              <div className="orderTimer">
                {timeRemaining && (
                  <>
                    Order within next <span>{timeRemaining}</span>
                  </>
                )}
              </div>
            </div>
            <div>
              <img
                src="https://images.myloapp.in/NestJsUploads/1744183648693-Layer-1-2.webp"
                alt=""
                style={{
                  width: '30px',
                  height: '45px',
                  margin: '15px 10px 0 auto',
                }}
              />
            </div>
          </div>
        </>
      ) : (
        <p style={{ marginTop: '20px' }}>{showDispatchTime}</p>
      )}
    </CheckDeliveryTime>
  );
};

export default PdpNddSddStrip;
